export const botMessageActions = [
    {
        label: 'Navigate to Screen',
        value: 'navigate'
    },
    {
        label: 'Open URL',
        value: 'url'
    },
    {
        label: 'Open Drawer',
        value: 'drawer'
    }
]

export const botMessageActionsNavigationOptions = [
    {
        label: 'Settings',
        value: 'settings',
        location: '/account/profile/'
    },
    {
        label: 'Settings -> Preferences',
        value: 'theme',
        location: '/account/preferences/'
    },
    {
        label: 'Settings -> Profile',
        value: 'profile',
        location: '/account/profile/'
    },
    {
        label: 'Settings -> My Agencies',
        value: 'myAgencies',
        location: '/account/departments/'
    },
    {
        label: 'Settings -> Edit Email',
        value: 'editEmail',
        location: '/account/profile/'
    },
    {
        label: 'Settings -> Notifications',
        value: 'notifications',
        location: '/account/notifications/'
    },
    {
        label: 'Settings -> PIN',
        value: 'editPIN',
        location: 'mobile'
    },
    {
        label: 'Settings -> Reset Password',
        value: 'resetPassword',
        location: '/account/profile/'
    },
    {
        label: 'Documents',
        value: 'documents',
        location: '/everdocs/'
    },
    {
        label: 'Join Room',
        value: 'joinRoom',
        location: 'modal'
    },
    {
        label: 'Create Room',
        value: 'createRoom',
        location: 'modal'
    },
    {
        label: 'Start DM',
        value: 'startThread',
        location: 'modal'
    },
    {
        label: 'Invite Screen',
        value: 'invite',
        location: 'modal',
        params: {}
    },
    {
        label: 'Invite to Agency',
        value: 'inviteDepartment',
        location: 'modal',
        params: {type: 'department'}
    },
    {
        label: 'Invite to Room',
        value: 'inviteRoom',
        location: 'modal',
        params: {type: 'room'}
    },
    {
        label: 'Invite People to DM',
        value: 'inviteContact',
        location: 'modal',
        params: {type: 'contact'}
    },
    {
        label: 'Room',
        value: 'room',
        location: '/room'
    },
    {
        label: 'Thread',
        value: 'thread',
        location: '/thread'
    }
]

export const ctaColorOptions = [
    {label: 'Primary', value: 'primary'},
    {label: 'Secondary', value: 'secondary'},
    {label: 'Success Green', value: 'success'},
    {label: 'Warning Yellow', value: 'warning'},
    {label: 'Danger Red', value: 'danger'},
    {label: 'Primary Outline Only', value: 'border'},
    {label: 'Transparent', value: 'link'}
]
